import React from 'react';
import { HonestRealtor } from '../../../../components/HonestRealtor';
import { Label } from '../../../../components/Label';
import { useOfferContext } from '../../../../context';

export function AgentReliableBadgeContainer() {
  const { isProAgent, isHonestAgent } = useOfferContext();

  if (!isProAgent && !isHonestAgent) {
    return null;
  }

  return (
    <>
      {isHonestAgent && <HonestRealtor text="Работаю честно" />}
      {isProAgent && <Label size="XS" text="PRO" />}
    </>
  );
}
